<div class="sequence-card">
    <div class="google-map-container">
        <google-map #map [zoom]="zoom" [center]="center" [options]="options" width="100%" height="100%"
            (centerChanged)="onMapChange()" (zoomChanged)="onMapChange()">
            <map-ground-overlay *ngIf="overlayImage" [url]="overlayImage" [bounds]="bounds"
                [opacity]="1"></map-ground-overlay>
            <map-polygon *ngFor="let path of polygon" [paths]="path" [options]="polygonOptions"></map-polygon>

            <div class="overlay-label-container">
                <span *ngIf="card?.title" class="overlay-label-type">{{card?.title}}</span>
                <span class="overlay-label-dot" *ngIf="card?.title && card?.content"> · </span>
                <span class="overlay-label-date">{{card?.content}}</span>
            </div>

            <div *ngIf="showLegends && isLoadingLegends" class="legend-container">
                <div class="legend-loading">
                    <span class="material-icons text-gray-300 animate-spin text-[18px]">autorenew</span>
                    <span class="loading-text">Loading legend...</span>
                </div>
            </div>

            <div *ngIf="showLegends && !isLoadingLegends && fieldLegends.length > 0" class="legend-container">
                <div class="legend-content">
                    <div class="legend-item" *ngFor="let legend of fieldLegends">
                        <div class="legend-color" [style.background-color]="legend.color"></div>
                        <label class="legend-value">({{ legend.minValue | number : '1.3-3'}}) - ({{ legend.maxValue | number : '1.3-3'}})</label>
                    </div>
                </div>
            </div>
        </google-map>
    </div>
</div>